<template>
  <div v-if="!finishAsistent" class="volonter">
    <form @submit.prevent="onSubmit">

      <h3>Lični podaci o potencijalnom asistentu/kinji</h3>

      <h4>1. Ime i prezime</h4>
      <InputText type="text" placeholder="Unesite ime i prezime" v-model="firstAndLastName" />

      <h4>2. Pol</h4>
      <Dropdown
        v-model="gender"
        :options="genders"
        placeholder="Izaberite"
        class="dropdown"
      />

      <h4>3. Datum rođenja</h4>
      <Calendar
        v-model="dateOfBirth"
        showIcon
        :dateFormat="dateFormat"
        placeholder="dd/mm/yyyy"
        class="calendar"
        :manualInput="false"
        showButtonBar
        :yearNavigator="true"
        :yearRange="`1930:${new Date().getFullYear()}`"
        :maxDate="new Date()"
      />

      <h4>4. Državljanstvo</h4>
      <LocationSelect
        v-model:country="drzavljanstvo"
        :showCity="false"
        countryPlaceholder="Odaberite državljanstvo"
      />

      <h4>5. Adresa</h4>
      <LocationSelect
        v-model:country="state"
        v-model:city="city"
        countryPlaceholder="Odaberite državu"
        cityPlaceholder="Odaberite grad"
      />
      <InputText
          type="text"
          placeholder="Ulica i broj"
          class="inline-input"
          v-model="streetAndNumber"
      />

      <h4>6. Kontakt podaci</h4>
      <PhoneInput v-model="mobilePhone" placeholder="Broj mobilnog telefona" class="inline-input" />
      <InputText
        type="text"
        placeholder="E-mail adresa"
        class="inline-input"
        v-model="email"
      />
      <PhoneInput v-model="viber" placeholder="Viber" class="inline-input" />
      <PhoneInput v-model="whatsapp" placeholder="WhatsApp" class="inline-input" />
      <PhoneInput v-model="signal" placeholder="Signal" class="inline-input" />
      <PhoneInput v-model="telegram" placeholder="Telegram" class="inline-input" />

      <h4>7. Školska sprema</h4>
      <Dropdown
        v-model="educationalBackground"
        :options="educational"
        placeholder="Izaberite"
        class="dropdown"
      />

      <h4>8. Zvanje</h4>
      <InputText type="text" placeholder="Unesite Vaše zvanje" v-model="zvanje" />

      <h4>9. Radni status</h4>
      <Dropdown
        v-model="workStatus"
        :options="workStatuses"
        placeholder="Izaberite"
        class="dropdown"
      />

      <!-- ========== II DIO: ZAINTERESOVANOST ========== -->

      <h3>Zainteresovanost za pružanje asistencije</h3>

      <h4>1. Da li ste imali iskustva u radu s osobama s invaliditetom?</h4>
      <div class="button-container">
        <div class="checkbox-label">
          <RadioButton name="choiceExp" value="Da" inputId="expYes" v-model="experienceWithDisabilities" />
          <label for="expYes" class="label">Da</label>
          <RadioButton name="choiceExp" value="Ne" inputId="expNo" v-model="experienceWithDisabilities" />
          <label for="expNo" class="label">Ne</label>
        </div>
      </div>
      <div v-if="experienceWithDisabilities === 'Da'">
        <h4>Ukratko opišite svoje iskustvo.</h4>
        <Textarea v-model="experienceDescription" autoResize rows="3" cols="47" />
      </div>

      <h4>2. Kojim korisnicima biste najradije pružali personalnu asistenciju ili pomoć u kući? <br>Možete izabrati više odgovora</h4>
      <div class="relative">
        <MultiSelect
          v-model="preferredUsers"
          :options="preferredUserOptions"
          optionLabel="period"
          placeholder="Izaberite"
          :maxSelectedLabels="20"
          selectedItemsLabel="{0} izabrano"
          appendTo="body"
          :panelStyle="{ maxWidth: 'calc(100vw - 40px)', overflowX: 'hidden' }"
        />
      </div>

      <h4>3. U kojim aktivnostima biste pružali asistenciju osobama s invaliditetom? <br>Možete izabrati više odgovora</h4>
      <div class="relative">
        <MultiSelect
          v-model="assistanceActivities"
          :options="assistanceActivityOptions"
          optionLabel="period"
          placeholder="Izaberite"
          :maxSelectedLabels="20"
          selectedItemsLabel="{0} izabrano"
          appendTo="body"
          :panelStyle="{ maxWidth: 'calc(100vw - 40px)', overflowX: 'hidden' }"
        />
      </div>

      <h4>4. U kom vremenskom periodu možete pružati personalnu asistenciju ili pomoć u kući? <br>Možete izabrati više odgovora</h4>
      <div class="relative">
        <MultiSelect
          v-model="availableTimePeriods"
          :options="timePeriodOptions"
          optionLabel="period"
          placeholder="Izaberite"
          :maxSelectedLabels="20"
          selectedItemsLabel="{0} izabrano"
          appendTo="body"
        />
      </div>

      <h4>5. Da li umijete da koristite pomagala i/ili asistivnu tehnologiju?</h4>
      <div class="button-container">
        <div class="checkbox-label">
          <RadioButton name="choiceTech" value="Da" inputId="techYes" v-model="assistiveTechYesNo" />
          <label for="techYes" class="label">Da</label>
          <RadioButton name="choiceTech" value="Ne" inputId="techNo" v-model="assistiveTechYesNo" />
          <label for="techNo" class="label">Ne</label>
        </div>
      </div>
      <div v-if="assistiveTechYesNo === 'Da'">
        <h4>Koja pomagala i/ili asistivnu tehnologiju umijete da koristite?</h4>
        <Textarea v-model="assistiveTechDescription" autoResize rows="3" cols="47" />
      </div>

      <h4>6. Da li imate zdravstvenih problema?</h4>
      <div class="button-container">
        <div class="checkbox-label">
          <RadioButton name="choiceHealth" value="Da" inputId="healthYes" v-model="healthProblemsYesNo" />
          <label for="healthYes" class="label">Da</label>
          <RadioButton name="choiceHealth" value="Ne" inputId="healthNo" v-model="healthProblemsYesNo" />
          <label for="healthNo" class="label">Ne</label>
        </div>
      </div>
      <div v-if="healthProblemsYesNo === 'Da'">
        <h4>Koje zdravstvene probleme imate?</h4>
        <Textarea v-model="healthProblemsDescription" autoResize rows="3" cols="47" />
      </div>

      <h4>7. Da li govorite neki od stranih jezika?</h4>
      <div class="button-container">
        <div class="checkbox-label">
          <RadioButton name="choiceLang" value="Da" inputId="langYes" v-model="foreignLanguagesYesNo" />
          <label for="langYes" class="label">Da</label>
          <RadioButton name="choiceLang" value="Ne" inputId="langNo" v-model="foreignLanguagesYesNo" />
          <label for="langNo" class="label">Ne</label>
        </div>
      </div>
      <div v-if="foreignLanguagesYesNo === 'Da'">
        <h4>Koji/e strani/e jezik/e govorite i na kojem nivou?</h4>
        <Textarea v-model="foreignLanguagesDescription" autoResize rows="3" cols="47" />
      </div>

      <h4>8. Da li poznajete rad na računaru?</h4>
      <div class="button-container">
        <div class="checkbox-label">
          <RadioButton name="choicePC" value="Da" inputId="pcYes" v-model="computerSkillsYesNo" />
          <label for="pcYes" class="label">Da</label>
          <RadioButton name="choicePC" value="Ne" inputId="pcNo" v-model="computerSkillsYesNo" />
          <label for="pcNo" class="label">Ne</label>
        </div>
      </div>
      <div v-if="computerSkillsYesNo === 'Da'">
        <h4>Koje programe i na kojem nivou koristite?</h4>
        <Textarea v-model="computerSkillsDescription" autoResize rows="3" cols="47" />
      </div>

      <h4>9. Zašto se prijavljujete za personalnog/u i/ili asistenta/kinju u kući?</h4>
      <Textarea v-model="whyApplying" autoResize rows="3" cols="47" />

      <h4>10. Što Vas izdvaja od ostalih kandidata?</h4>
      <Textarea v-model="whatSetsYouApart" autoResize rows="3" cols="47" />

      <h4>11. Koja su Vaša očekivanja u pogledu Vašeg angažmana u ulozi personalnog/e i/ili asistenta/kinje u kući?</h4>
      <Textarea v-model="expectations" autoResize rows="3" cols="47" />

      <h4>12. Priložite svoj CV.</h4>
      <div class="cv-upload">
        <label class="cv-upload-label" @click="$refs.cvInput.click()">
          <i class="pi pi-upload" style="margin-right: 8px;"></i>
          {{ cvFileName || 'Izaberite fajl (.pdf, .doc, .docx)' }}
        </label>
        <input ref="cvInput" type="file" accept=".pdf,.doc,.docx" @change="onFileChange" style="display: none;" />
      </div>

      <h4>13. Ukoliko imate nešto da kažete što nije obuhvaćeno prethodnim pitanjima, molimo Vas navedite.</h4>
      <Textarea v-model="additionalComments" autoResize rows="3" cols="47" />

      <h4>14. Da li dajete saglasnost da I MI Boke može prikupljati, čuvati i analizirati Vaše podatke koje pružate, u svrhu eventualnog angažmana u ulozi personalnog/e i/ili asistenta/kinje u kući?</h4>
      <div class="button-container">
        <div class="checkbox-label">
          <RadioButton name="choiceConsent" value="Da" inputId="consentYes" v-model="giveConsent" />
          <label for="consentYes" class="label">Da</label>
          <RadioButton name="choiceConsent" value="Ne" inputId="consentNo" v-model="giveConsent" />
          <label for="consentNo" class="label">Ne</label>
        </div>
      </div>
      <div v-if="giveConsent === 'Da'">
        <p style="color: #1a73e8;">Svoju Saglasnost možete povući u bilo koje doba putem poziva na broj 068 022 805 ili slanjem mejla na podrska@imiboke.me</p>
      </div>
      <div v-if="giveConsent === 'Ne'">
        <p style="color: red;">Razumijemo Vašu nespremnost da podijelite pružene podatke, ali Vaša Prijava ne može biti podnijeta sve dok nam tu saglasnost ne date.</p>
        <div class="button-container">
          <Button @click="giveConsent = null" class="sendAnswers" type="button" outlined>Nazad</Button>
        </div>
      </div>

      <div v-if="errorMessage" class="error-message">
        <p>{{ errorMessage }}</p>
      </div>

      <div v-if="giveConsent === 'Da'" class="button-container">
        <Button type="submit" class="sendAnswers" :loading="isSubmitting" :disabled="isSubmitting">
          {{ isSubmitting ? 'Šaljem...' : 'Pošalji odgovor' }}
        </Button>
      </div>

    </form>
  </div>
  <AsistentFinish v-if="finishAsistent" />
</template>

<script setup>
import { ref, computed } from "vue";
import { useToast } from "primevue/usetoast";
import AsistentFinish from "./AsistentFinish.vue";
import PhoneInput from "./PhoneInput.vue";
import LocationSelect from "./LocationSelect.vue";

const toast = useToast();

// ========== Date helpers ==========

const dateFormat = "dd/mm/yy";

function formatDateFull(datum) {
  if (!datum) return "";
  const d = new Date(datum);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
}

// ========== Dropdown option lists ==========

const genders = ["Muški", "Ženski", "Ne želim da kažem"];

const educational = [
  "Srednja škola III stepen",
  "Srednja škola IV stepen",
  "Viša škola",
  "Visoka škola",
  "Master",
  "Doktor nauka",
];

const workStatuses = [
  "Angažovan/na honorarno",
  "Zaposlen/a na nepuno radno vrijeme",
  "Zaposlen/a na puno radno vrijeme",
  "Nezaposlen/a",
  "Na školovanju",
  "Penzioner/ka",
];

const preferredUserOptions = [
  { period: "Svejedno mi je" },
  { period: "Djeci sa fizičkim invaliditetom (motorički, otežano pomjeranje i/ili kretanje)" },
  { period: "Mladima sa fizičkim invaliditetom (motorički, otežano pomjeranje i/ili kretanje)" },
  { period: "Odraslima sa fizičkim invaliditetom (motorički, otežano pomjeranje i/ili kretanje)" },
  { period: "Djeci s oštećenjem vida" },
  { period: "Mladima s oštećenjem vida" },
  { period: "Odraslima s oštećenjem vida" },
  { period: "Djeci s oštećenjem sluha i/ili govora" },
  { period: "Mladima s oštećenjem sluha i/ili govora" },
  { period: "Odraslima s oštećenjem sluha i/ili govora" },
  { period: "Djeci s intelektualnim invaliditetom (smanjen IQ)" },
  { period: "Mladima s intelektualnim invaliditetom (smanjen IQ)" },
  { period: "Odraslima s intelektualnim invaliditetom (smanjen IQ)" },
  { period: "Djeci sa psihosocijalnim invaliditetom (mentalni/psihički/duševni invaliditet, autizam i sl.)" },
  { period: "Mladima sa psihosocijalnim invaliditetom (mentalni/psihički/duševni invaliditet, autizam i sl.)" },
  { period: "Odraslima sa psihosocijalnim invaliditetom (mentalni/psihički/duševni invaliditet, autizam i sl.)" },
  { period: "Djeci sa višestrukim invaliditetom" },
  { period: "Mladima sa višestrukim invaliditetom" },
  { period: "Odraslima sa višestrukim invaliditetom" },
];

const assistanceActivityOptions = [
  { period: "Održavanje lične higijene" },
  { period: "Oblačenje i svlačenje" },
  { period: "Podizanje i premještanje (transferi)" },
  { period: "Hranjenje" },
  { period: "Uzimanje terapije" },
  { period: "Davanje injekcija" },
  { period: "Korišćenje respiratora i aspiratora" },
  { period: "Korišćenje i održavanje pomagala" },
  { period: "Briga o kućnim ljubimcima i/ili asistivnim životinjama" },
  { period: "Održavanje higijene stambenog prostora, posteljine i garderobe" },
  { period: "Priprema obroka" },
  { period: "Obavljanje trgovine" },
  { period: "Obavljanje administrativnih poslova" },
  { period: "Kretanje i korišćenje prevoza" },
  { period: "Odlasci kod ljekara" },
  { period: "Druženja" },
  { period: "Kultura" },
  { period: "Zabava" },
  { period: "Višednevna putovanja" },
  { period: "Izleti" },
  { period: "Igra" },
  { period: "Sportske aktivnosti" },
  { period: "Vjerski obredi" },
  { period: "Posao" },
  { period: "Obrazovanje" },
  { period: "Drugo, navedite" },
];

const timePeriodOptions = [
  { period: "Prije podne" },
  { period: "Poslije podne" },
  { period: "Uveče" },
  { period: "Noću" },
  { period: "Radnim danima" },
  { period: "Vikendima" },
  { period: "Tokom državnih praznika" },
  { period: "Tokom godišnjeg odmora" },
  { period: "Bilo koje vrijeme" },
  { period: "Bilo koji dan" },
];

// ========== Form state ==========

// Section 1 - Lični podaci
const firstAndLastName = ref("");
const gender = ref(null);
const dateOfBirth = ref(null);
const drzavljanstvo = ref("");
const streetAndNumber = ref("");
const city = ref("");
const state = ref("");
const mobilePhone = ref("");
const email = ref("");
const viber = ref("");
const whatsapp = ref("");
const signal = ref("");
const telegram = ref("");
const educationalBackground = ref(null);
const zvanje = ref("");
const workStatus = ref(null);

// Section 2 - Zainteresovanost
const experienceWithDisabilities = ref(null);
const experienceDescription = ref("");
const preferredUsers = ref([]);
const assistanceActivities = ref([]);
const availableTimePeriods = ref([]);
const assistiveTechYesNo = ref(null);
const assistiveTechDescription = ref("");
const healthProblemsYesNo = ref(null);
const healthProblemsDescription = ref("");
const foreignLanguagesYesNo = ref(null);
const foreignLanguagesDescription = ref("");
const computerSkillsYesNo = ref(null);
const computerSkillsDescription = ref("");
const whyApplying = ref("");
const whatSetsYouApart = ref("");
const expectations = ref("");
const cvFile = ref(null);
const cvFileName = computed(() => cvFile.value ? cvFile.value.name : null);
const additionalComments = ref("");
const giveConsent = ref(null);

// UI state
const finishAsistent = ref(false);
const isSubmitting = ref(false);
const errorMessage = ref(null);

// ========== Handlers ==========

function onFileChange(event) {
  cvFile.value = event.target.files[0] || null;
}

function extractPeriodValues(items) {
  if (!items || !items.length) return [];
  return items.map(item => item.period || item);
}

async function onSubmit() {
  if (giveConsent.value !== 'Da') return;

  isSubmitting.value = true;
  errorMessage.value = null;
  const apiUrl = process.env.VUE_APP_API_URL;
  const fd = new FormData();

  // Section 1 - Lični podaci
  fd.append("firstAndLastName", firstAndLastName.value);
  fd.append("gender", gender.value || "");
  fd.append("dateOfBirth", formatDateFull(dateOfBirth.value));
  fd.append("citizenship", drzavljanstvo.value);
  fd.append("streetAndNumber", streetAndNumber.value);
  fd.append("city", city.value);
  fd.append("country", state.value);
  fd.append("mobilePhone", mobilePhone.value);
  fd.append("email", email.value);
  fd.append("viber", viber.value);
  fd.append("whatsapp", whatsapp.value);
  fd.append("signal", signal.value);
  fd.append("telegram", telegram.value);
  fd.append("educationLevel", educationalBackground.value || "");
  fd.append("profession", zvanje.value);
  fd.append("workStatus", workStatus.value || "");

  // Section 2 - Zainteresovanost
  fd.append("experienceWithDisabledPersons", experienceWithDisabilities.value === 'Da');
  fd.append("experienceDescription", experienceDescription.value);

  for (const val of extractPeriodValues(preferredUsers.value)) {
    fd.append("preferredUserGroups", val);
  }
  for (const val of extractPeriodValues(assistanceActivities.value)) {
    fd.append("assistanceActivities", val);
  }
  for (const val of extractPeriodValues(availableTimePeriods.value)) {
    fd.append("availabilityPeriods", val);
  }

  fd.append("knowsAssistiveTechnology", assistiveTechYesNo.value === 'Da');
  fd.append("assistiveTechnologyDetails", assistiveTechDescription.value);
  fd.append("hasHealthProblems", healthProblemsYesNo.value === 'Da');
  fd.append("healthProblemsDetails", healthProblemsDescription.value);
  fd.append("speaksForeignLanguages", foreignLanguagesYesNo.value === 'Da');
  fd.append("foreignLanguagesDetails", foreignLanguagesDescription.value);
  fd.append("knowsComputers", computerSkillsYesNo.value === 'Da');
  fd.append("computerDetails", computerSkillsDescription.value);
  fd.append("reasonForApplying", whyApplying.value);
  fd.append("whatDistinguishesYou", whatSetsYouApart.value);
  fd.append("expectations", expectations.value);
  fd.append("additionalNotes", additionalComments.value);
  fd.append("dataCollectionConsent", giveConsent.value === 'Da');

  if (cvFile.value) {
    fd.append("cvFile", cvFile.value);
  }

  try {
    const response = await fetch(`${apiUrl}/assistant-part/save`, {
      method: "POST",
      body: fd,
    });

    if (response.status === 422) {
      const data = await response.json().catch(() => null);
      const detail = data ? Object.values(data).join(". ") : "Molimo Vas da provjerite unesene podatke i pokušate ponovo.";
      errorMessage.value = detail;
      toast.add({ severity: "warn", summary: "Provjerite podatke", detail, life: 6000 });
      return;
    }

    if (response.status >= 500) {
      const detail = "Došlo je do greške na serveru. Molimo Vas pokušajte ponovo kasnije.";
      errorMessage.value = detail;
      toast.add({ severity: "error", summary: "Greška servera", detail, life: 6000 });
      return;
    }

    if (!response.ok) {
      const detail = "Došlo je do greške. Molimo Vas pokušajte ponovo.";
      errorMessage.value = detail;
      toast.add({ severity: "error", summary: "Greška", detail, life: 6000 });
      return;
    }

    finishAsistent.value = true;
    toast.add({
      severity: "success",
      summary: "Uspješno",
      detail: "Vaša prijava je sačuvana.",
      life: 4000,
    });
  } catch (error) {
    console.error("Error sending data to server:", error);
    const detail = "Nije moguće povezati se sa serverom. Provjerite internet konekciju i pokušajte ponovo.";
    errorMessage.value = detail;
    toast.add({ severity: "error", summary: "Veza prekinuta", detail, life: 6000 });
  } finally {
    isSubmitting.value = false;
  }
}
</script>

<style scoped>
h3 {
  text-align: center;
  color: #1a73e8;
  border-bottom: 2px solid #1a73e8;
  padding-bottom: 10px;
  margin-top: 30px;
}

.cv-upload {
  margin-bottom: 10px;
}

.cv-upload-label {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  background-color: #fff;
  color: #64748b;
  cursor: pointer;
  transition: border-color 0.2s, background-color 0.2s;
  font-size: 1rem;
}

.error-message {
  background-color: #fef2f2;
  border: 1px solid #fca5a5;
  border-radius: 6px;
  padding: 12px 16px;
  margin-bottom: 10px;
}

.error-message p {
  color: #dc2626;
  margin: 0;
  text-align: center;
}

.cv-upload-label:hover {
  border-color: #94a3b8;
  background-color: #f8fafc;
}
</style>
